import { useEffect, useState } from 'react';
import { getArticleBySlug } from '../../../lib/articles';

export const useArticleContent = (slug) => {
  const [status, setStatus] = useState('loading');
  const [articleHtml, setArticleHtml] = useState('');
  const [frontmatter, setFrontmatter] = useState({});
  const [readingTime, setReadingTime] = useState(null);

  useEffect(() => {
    if (!slug) {
      setStatus('error');
      return;
    }

    let active = true;

    const fetchArticle = async () => {
      setStatus('loading');

      try {
        const article = await getArticleBySlug(slug);
        if (!active) {
          return;
        }

        if (!article) {
          setStatus('error');
          return;
        }

        setArticleHtml(article.html || '');
        setFrontmatter(article.frontmatter || {});
        setReadingTime(article.readTime || article.readingTime || null);
        setStatus('success');
      } catch (_error) {
        if (!active) {
          return;
        }
        setStatus('error');
      }
    };

    fetchArticle();

    return () => {
      active = false;
    };
  }, [slug]);

  return {
    status,
    articleHtml,
    frontmatter,
    readingTime,
  };
};
